/* eslint-disable import/prefer-default-export */
// Build-time feature flag for the Auth0 → Better Auth migration.
// Auth0 remains the default until CEO sign-off (see BETTER_AUTH_MIGRATION.md).
export const BETTER_AUTH_ENABLED =
  process.env.REACT_APP_BETTER_AUTH_ENABLED === 'true';
